import { Box, Card, Text } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

interface TargetScoreCardProps {
  title: string
  score: number
  scaleMax: number
}

export const TargetScoreCard: React.FC<TargetScoreCardProps> = ({ title, score, scaleMax }) => {
  return (
    <Box width="full" gridColSpan={{ xxs: 3 }}>
      <Card key={title}>
        <Card.Title>{title}</Card.Title>
        <Card.Content>
          <Box flexDirection="row" alignItems="baseline">
            <Text size="700" weight="bold" color="grey1000">
              {i18n.formatNumber(score)}
            </Text>
            <Text size="500" weight="medium" color="grey1000">
              /{i18n.formatNumber(scaleMax)}
            </Text>
          </Box>
        </Card.Content>
      </Card>
    </Box>
  )
}
